export var slice = [].slice;



//////////////////
// WEBPACK FOOTER
// ./~/d3-queue/src/array.js
// module id = 2101
// module chunks = 0